import React, { useState } from 'react'
import GenericModal from '../../../components/GenericModal'
import CsvMappingUpload from '../../../components/CsvMappingUpload'
import Dropdown from '../../../components/Dropdown'
import CreateAndEditFacultyAndStaff from '../CreateAndEditFacultyAndStaff'
import { ButtonType } from '../../../components/GenericButton/styles'
import { notification } from '../../../components/Notifications'
import { getTerm } from '../../../store/slices/termsSlice/selectors'
import api from '../../../utils/api'
import { exportCsv } from '../../../utils/exportCsv'
import { grey } from '../../../colors'
import { type ApplyFiltersAndDispatchParams } from '../../../components/CustomTable/types'

interface FacultyAndStaffTopbarActionsProps {
  params?: ApplyFiltersAndDispatchParams
}

const FacultyAndStaffTopbarActions: React.FC<FacultyAndStaffTopbarActionsProps> = ({ params }) => {
  const [isUploadModal, setIsUploadModal] = useState<boolean>(false)
  const [isUploadRolesModal, setIsUploadRolesModal] = useState<boolean>(false)
  const [isCreateModal, setIsCreateModal] = useState<boolean>(false)
  const [loadingExport, setLoadingExport] = useState(false)

  const closeUploadModal = (): void => {
    setIsUploadModal(false)
    setIsUploadRolesModal(false)
  }

  const closeUploadRolesModal = (): void => {
    setIsUploadRolesModal(false)
  }

  const uploadApi = (): void => {
    setIsUploadModal(true)
  }

  const handleUploadRolesModal = (): void => {
    setIsUploadRolesModal(true)
  }

  const addManually = (): void => {
    setIsCreateModal(true)
  }

  const term = getTerm()

  const handleExportFaculty = async (): Promise<void> => {
    setLoadingExport(true)
    try {
      const exportParams = {
        isFaculty: true,
        search: params?.search || '',
        sort: params?.sort || undefined,
        pageSize: params?.pageSize || 15
      }
      const response = await api.get('/api/users/export/', { params: exportParams })
      const data = response?.data

      if (data) {
        exportCsv({ data, headers: response?.headers })
      }
    } catch (error: any) {
      notification(error?.message ?? 'Internal server error', { variant: 'error' })
    } finally {
      setLoadingExport(false)
    }
  }

  const handleExportFacultyRoles = async (): Promise<void> => {
    setLoadingExport(true)
    try {
      const exportParams = {
        isAdmin: true,
        search: params?.search || '',
        sort: params?.sort || undefined,
        pageSize: params?.pageSize || 15
      }
      const response = await api.get('/api/users/roles/export/', { params: exportParams })
      const data = response?.data

      if (data) {
        exportCsv({ data, headers: response?.headers })
      }
    } catch (error: any) {
      notification(error?.message ?? 'Internal server error', { variant: 'error' })
    } finally {
      setLoadingExport(false)
    }
  }

  const actionsMenuItems = [
    { text: 'Upload Faculty (.csv)', action: uploadApi },
    { text: 'Upload Faculty Roles (.csv)', action: handleUploadRolesModal },
    { text: 'Add Manually', action: addManually }
  ]

  const exportMenuItems = [
    { text: 'Export Faculty (.csv)', action: handleExportFaculty, disabled: loadingExport },
    { text: 'Export Faculty Roles (.csv)', action: handleExportFacultyRoles, disabled: loadingExport }
  ]

  return (
    <>
      <Dropdown menuItems={exportMenuItems} label='Export' extraButtonProps={{ buttonType: ButtonType.Secondary, loading: loadingExport, disabled: loadingExport, circularProgressStyles: { color: grey[300] } }} />
      <Dropdown menuItems={actionsMenuItems} label='Add Faculty' extraButtonProps={{ buttonType: ButtonType.Primary }} />
      <GenericModal
        isOpen={isCreateModal}
        title={'Add Faculty'}
        onClose={() => { setIsCreateModal(false) }}
        maxWidth='sm'
        action={false}
      >
        <CreateAndEditFacultyAndStaff handleCloseModal={() => { setIsCreateModal(false) }} />
      </GenericModal>

      <CsvMappingUpload isOpen={isUploadModal} onClose={closeUploadModal} modalTitle="Faculty" csvHeaderEndpoint="/api/users/csv_headers" uploadCsvEndpoint="/api/users/?is_faculty=True" onSuccess={() => { notification('Faculty successfully uploaded', { variant: 'success' }) }} />

      <CsvMappingUpload isOpen={isUploadRolesModal} onClose={closeUploadRolesModal} modalTitle="Roles" csvHeaderEndpoint="/api/users/roles/csv_headers" uploadCsvEndpoint={'/api/users/roles/'} uploadCsvEndpointApiParams={{ isFaculty: true, termId: term?.termId }} onSuccess={() => { notification('Roles successfully uploaded', { variant: 'success' }) }}
      />
    </>

  )
}

export default FacultyAndStaffTopbarActions
